import { makeVar } from '@apollo/client';

import { IOption } from '../../@types/option';

export interface ILearningPathsDrawerState {
  isOpen: boolean;
  selectedOccupation: IOption | null;
}

export const learningPathsDrawerVar = makeVar<ILearningPathsDrawerState>({
  isOpen: false,
  selectedOccupation: null,
});
